var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloud = function SvgCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B4CFFF",
    fillRule: "evenodd",
    d: "M55.875 44.746H15.672v-.009q-.26.01-.523.01C6.783 44.746 0 37.963 0 29.596s6.783-15.15 15.15-15.15c1.006 0 1.99.099 2.942.286C21.53 8.343 28.28 4 36.045 4c8.489 0 15.765 5.192 18.827 12.574q.507-.037 1.024-.037c7.79 0 14.104 6.315 14.104 14.105 0 7.26-5.485 13.239-12.537 14.018v.086h-1.588m-29.647-5.583a4.688 4.688 0 1 1-9.377 0 4.688 4.688 0 0 1 9.377 0m6.688-1.875a2 2 0 0 0-2 2v.688a2 2 0 0 0 2 2h19.44a2 2 0 0 0 2-2v-.688a2 2 0 0 0-2-2z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    fillRule: "evenodd",
    d: "M11.225 33.662a2 2 0 0 1 2-2h42.882a2 2 0 0 1 2 2v11.94a2 2 0 0 1-2 2H13.225a2 2 0 0 1-2-2zm15.003 5.501a4.688 4.688 0 1 1-9.377 0 4.688 4.688 0 0 1 9.377 0m6.688-1.875a2 2 0 0 0-2 2v.688a2 2 0 0 0 2 2h19.44a2 2 0 0 0 2-2v-.688a2 2 0 0 0-2-2z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    fillRule: "evenodd",
    d: "M11.225 51.79a2 2 0 0 1 2-2h42.882a2 2 0 0 1 2 2v11.94a2 2 0 0 1-2 2H13.225a2 2 0 0 1-2-2zm15.003 5.5a4.688 4.688 0 1 1-9.377 0 4.688 4.688 0 0 1 9.377 0m6.688-1.875a2 2 0 0 0-2 2v.688a2 2 0 0 0 2 2h19.44a2 2 0 0 0 2-2v-.688a2 2 0 0 0-2-2z",
    clipRule: "evenodd"
  })));
};
export default SvgCloud;